import React, { useMemo } from 'react';
import {Modal} from 'react-bootstrap';
import './index.css';

export function ModalDommusTSX({...props}) {

  const dataCorte = useMemo(() => {
    if (!props.permissaoDataCorte) return null;

    return (
      <div className="modal-data-corte">
        <div>
          <label>Data de Corte:</label>
          <input
            type="date"
            className="input-data-corte"
            value={props.dataCorte}
            onChange={(e) =>
              props.buscarParcelasPorDataCorte(e.target.value)
            }
          />
        </div>
      </div>
    );
  }, [props.permissaoDataCorte, props.dataCorte, props.buscarParcelasPorDataCorte]);


  return <Modal show={props.open} onHide={props.close} size={props.size || "lg"}
								centered
								style={{
									zIndex: '1040',
									paddingRight: '17px',
									display: 'block'
								}}>
		<Modal.Header closeButton>
			<Modal.Title><h2>{props.titulo}</h2></Modal.Title>
      { dataCorte }
		</Modal.Header>
		<Modal.Body style={{...props.bodyStyle || {}}}>
			<div className={"conteudo"}>
				{props.content}
			</div>
		</Modal.Body>
	</Modal>;
}
